import Style from './Footer.module.css'
import Link from 'next/link'
import Logo from '../Logo'
import {
  IconX,
} from '../Icons'
import { useTranslations } from 'next-intl'

export default function AppFooter() {
  const year = new Date().getFullYear()
  const t = useTranslations('t')

  return (
    <footer className={Style.footer}>
      <div className={Style.container}>
        <ul>
          <li>
            <Link href="/" title="Ryen">
              <Logo />
            </Link>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              {t('slogan')}
            </p>
          </li>
        </ul>

        <ul>
          <li>
            <Link href="/about">{t('about')}</Link>
          </li>
          <li>
            <Link href="/community">{t('community')}</Link>
          </li>
          <li>
            <Link href="https://status.eggerco.com">{t('status')}</Link>
          </li>
          <li>
            <Link href="/terms">{t('terms')}</Link>
          </li>
          <li>
            <Link href="/privacy">{t('privacy')}</Link>
          </li>
        </ul>

        <ul>
          <li>
            <p>
              © {year} <Link href="https://www.eggerco.com">Egger, Inc.</Link> All rights reserved.
            </p>
          </li>
        </ul>

        <ul>
          <li>
            <Link
              href="https://x.com/RyenHQ"
              target="_blank"
              rel="noreferrer"
              aria-label="X">
              <IconX />
            </Link>
          </li>
        </ul>
      </div>
    </footer>
  )
}
